<template>
<div>
  <van-field
    :placeholder="placeholder"
    :label="label"
    v-model="customerName"
    :rules="rules"
    is-link
    readonly
    :required="required"
    :disabled="disabled"
    @click="handleClick"
  />
  <van-action-sheet
    title="客户"
    v-model="showCustomers"
    :actions="customers"
    cancel-text="取消"
    close-on-click-action
    @select="handleCustomerSelect"
    @cancel="showCustomers=false"
  />
</div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      default: '客户名称'
    },
    value: String,
    name: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
  },
  model: {
    event: 'input',
  },
  data() {
    return {
      customerName: '',
      customerId: '',
      customers: [],
      showCustomers: false,
    }
  },
  watch: {
    name(val) {
      this.customerName = val
    }
  },
  created() {
    this.getCustomers()
  },
  methods: {
    handleClick() {
      if(this.disabled) return
      this.showCustomers = true
    },
    getCustomers() {
      this.$http.get('/base/baseCustomer/list', {pageNum: 1, pageSize: 1000}).then(res => {
        this.customers = res.rows.map(item => {
          return {name: `${item.customerName}`, id: item.id}
        })
      })
    },
    handleCustomerSelect(customer) {
      const {name, id} = customer
      this.customerName = name
      this.customerId = id
      this.$emit('input', id)
      this.$emit('selected', name)
    },
  },
}
</script>

<style>

</style>